<template>
  <div class="favorites-wrap">
    <h3>我的收藏</h3>
    <div class="items-list" v-if="Array.isArray(list) && list.length">
      <template v-for="(item, index) in list">
        <BaseItem :source="item" :enableFavorite="true" :key="index" @favorite="onToggleFavorite" />
      </template>
    </div>
    <div class="favorites-empty" v-else>
      <div class="favorites-empty__tip">
        <div class="icon-wrap">
          <i class="iconfont">&#xe6a1;</i>
        </div>
        <div class="favorites-empty__msg">暂无收藏</div>
      </div>
      <button class="c-button c-button--primary favorites-empty__btn" @click="toHome">继续购物</button>
    </div>
  </div>
</template>

<script>
import BaseItem from "@/components/BaseItem.vue";
import types from "@/store/types";
import api from "@/utils/api";

export default {
  name: "Favorites",
  components: { BaseItem },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.loadSource();
  },
  methods: {
    loadSource() {
      api[types.FAV_LIST]().then(res => {
        if (res.code == 1) {
          this.list = res.data;
        } else if (res.code != 2) {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    onToggleFavorite(target) {
      let { ref, state } = target;
      if (ref && state === 0) {
        let idx = this.list.findIndex(item => item.unique_id == ref);
        idx != -1 && this.list.splice(idx, 1);
      }
    },
    toHome() {
      this.$router.push({ path: "/" });
    }
  }
}
</script>

<style lang="scss" scoped>
  .favorites-wrap {
    h3 { color:#333333; font-weight:bold; font-size: 1.125rem; padding: 1.6875rem 0 1.25rem 0; display: none; }
    .items-list {
      display: flex; flex-wrap: wrap; padding: 0 1rem;
      & /deep/ .plugin-wrapper {
        width: calc((100% - 20px) / 2); margin: 20px 20px 0 0;
        &:nth-child(-n+2) { margin-top: 0; }
        &:nth-child(2n) { margin-right: 0; }
      }
    }
    .favorites-empty {
      padding: 50px 0;
      .favorites-empty__tip {
        .icon-wrap {
          width: 5rem; height: 5rem; margin: 0 auto; background: rgb(246, 246, 246); border-radius: 50%; text-align: center;
          .iconfont { font-size: 2.25rem; color: rgb(195, 195, 195); line-height: 5rem; }
        }
        .favorites-empty__msg { font-size: 1.125rem; color: #000; font-weight: 700; text-align: center; margin-top: 1.25rem; }
      }
      .favorites-empty__btn { display: block; margin: 1.25rem auto 0 auto; }
    }
  }

  @media screen and (min-width: 48em) {
    .favorites-wrap {
      h3 { display: block; }
      .favorites-empty {
        display: flex; justify-content: space-between; align-items: center; padding: 3.125rem 3.125rem 3.125rem 5rem; border: 1px solid #DFDFDF;
        .favorites-empty__tip {
          display: flex; justify-content: flex-start; align-items: center;
          .favorites-empty__msg { margin-top: 0; margin-left: 1rem; }
        }
        .favorites-empty__btn { margin: 0; height: 2.8125rem; }
      }
    }
  }

  @media screen and (min-width: 64em) {
    .favorites-wrap {
      .items-list {
        display: flex; flex-wrap: wrap; padding: 0; margin-top: 30px;
        & /deep/ .plugin-wrapper {
          width: calc((100% - 40px) / 3);
          &:nth-child(-n+3) { margin-top: 0; }
          &:nth-child(2n) { margin-right: 20px; }
          &:nth-child(3n) { margin-right: 0; }
        }
      }
    }
  }
</style>